export interface User {
  id?: string;
  cognitoId?: string;
  firstName?: string | null;
  name: string;
  email?: string | null;
  phone?: string | null;
  role: 'SUPERADMIN' | 'ADMIN' | 'EMPLOYEE';
  /** Archived users keep all their data but can no longer sign in. */
  isArchived?: boolean | null;
  archivedAt?: string | null;
  settings?: UserSettings;
  tenants?: UserTenant[];
}

export interface UserTenant {
  id: string;
  userId: string;
  tenantId: string;
  tenant?: Tenant;
}

export interface Tenant {
  id: string;
  name: string;
  isActive?: boolean;
}

export interface UserSettings {
  id: string;
  userId: string;
  secondsToAvoid: string;
  aiInvoicePrompt?: string;
  displayModeForProject?: 'GANTT' | 'LIST';
  activitySplitPosition?: number;
  defaultTenantId?: string;
  dashboardSettings?: any;
  createdAt?: string;
  updatedAt?: string;
}

export const DEFAULT_INVOICE_PROMPT = `Write a professional, concise invoice description.
Summarize the performed tasks in 1–3 sentences.
Use a professional accounting tone. Avoid unnecessary details.`;
